import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SwqModalStatusModel } from '../models/swq-model-status.model';
import { SectionModel } from '../models/section.model';
import { literalConstant } from '../../shared/constant/literal.constant';
import { LookUpResourceModel } from '../models/lookup-resource.model';
import { ContractType } from '../../shared/models/contract/contract-type.model';
import { PostCjResponseResultModel } from '../../shared/customer-jouney/post-cj-response-result';
import { AbTestConfigModel } from 'src/app/shared/models/start-up-config/abtest-config-model';

@Injectable({
  providedIn: 'root'
})
export class SectionWiseService {
  private discardModalStateSubject = new Subject<boolean>();
  public discardModalState$: Observable<boolean> = this.discardModalStateSubject.asObservable();
  private swqModalStatusSubject: BehaviorSubject<SwqModalStatusModel> = new BehaviorSubject<SwqModalStatusModel>({
    swqModalIsOpen: false,
    question: new LookUpResourceModel()
  });
  public get swqModalStatus$(): Observable<SwqModalStatusModel> {
    return this.swqModalStatusSubject.asObservable();
  }

  sectionDetailsModel: Array<SectionModel>;

  constructor(
    public http: HttpClient,
    @Inject(literalConstant.API_URL) private baseUrl: string
  ) {}

  public openSwqModal(question: LookUpResourceModel): void {
    this.swqModalStatusSubject.next({
      swqModalIsOpen: true,
      question: question
    });
  }

  public closeSwqModal(question: LookUpResourceModel): void {
    this.swqModalStatusSubject.next({
      question: question,
      swqModalIsOpen: false
    });
  }

  public getHealthContractDetails(): Observable<ContractType> {
    return this.http.get<ContractType>(this.baseUrl + 'SectionWise/GetHealthContractDetails');
  }

  public getPartialCJContractDetails(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'partialCJ/getPartialCJContractDetails');
  }

  public postCjResponseSw(model: ContractType, abTestConfig: AbTestConfigModel, returnCode: string | null): Observable<PostCjResponseResultModel> {
    const headers = new HttpHeaders().set(literalConstant.ABTEST_SUBMISSION_HEADER, JSON.stringify(abTestConfig));
    let params = new HttpParams();
    if (returnCode) {
      params = params.set('returncode', returnCode);
    }
    return this.http.post<PostCjResponseResultModel>(this.baseUrl + 'sectionwise/SubmitRisk', model, { headers, params });
  }

  public setDiscardModalOpen(isModalOpen: boolean): void {

    this.discardModalStateSubject.next(isModalOpen);
  }
}
